<template>
  <div class="edit-style-border">
    <div>
        <div class="flex-box margin-none">
          <div>
            <label class="common-label">{{ labelText }}</label>
            <!-- 種類 -->
            <div v-if="kind === 'divider'" class="common-select">
              <select
                v-model="border.style"
                :value="border.style"
              >
                <option v-for="option in dividerOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div v-else class="common-select">
              <select
                v-model="border.style"
                :value="border.style"
              >
                <option v-for="option in options" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
        <div
          v-if="isShowExtraOption"
          class="text-color-box flex-box"
          >
          <!-- 太さ -->
          <div class="weight">
            <span class="common-label">太さ</span>
            <div class="common-input">
              <input v-model="border.width" type="text">
              <div class="weight-button plus-button-wrapper">
                <button
                  class="plus-button"
                  @mousedown="countWeight('plus')"
                  @mouseup="changeWeight('plus')"
                  @mouseleave="changeWeight('plus')"
                />
              </div>
              <div class="weight-button minus-button-wrapper">
                <button
                  class="minus-button"
                  @mousedown="countWeight('minus')"
                  @mouseup="changeWeight('minus')"
                  @mouseleave="changeWeight('minus')"
                />
              </div>
            </div>
          </div>
          <!-- 色 -->
          <div>
            <span class="common-label">色</span>
            <div class="common-input color-custom" @click="clickColorForm(target)">
              <div class="color-picker-label">
                <div class="active-color" :style="activeColorStyle"></div>
                {{ displayColorText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- カラーピッカー -->
    <color-picker
      v-on-clickaway="colorPickerAway"
      v-if="showColorPicker(target)"
      :selectColor="border.color"
      :transparent="false"
      @updateStyles="changeBorderColor($event)"
    />
  </div>
</template>

<script>
import ColorPicker from '@/components/Content/Palette/CommonLayouts/Colorpicker'
import EditStyleSelectBase from '@/components/Content/Palette/CommonLayouts/Base/EditStyleSelectBase'
import { mixin as onClickAway } from 'vue-clickaway'

const MAX_BORDER_WIDTH = 20
const MIN_BORDER_WIDTH = 0

export default {
  props: [
    'kind', // divider のみ
    'type', // section or partsContainer or part
    'target',
    'value'
  ],
  mixins: [
    onClickAway,
    EditStyleSelectBase,
  ],
  components: {
    ColorPicker,
  },
  data () {
    return {
      options: [],
      dividerOptions: [
        { text: '---', value: 'none' },
        { text: 'ソリッド', value: 'solid' },
        { text: 'ダッシュ', value: 'dashed' },
        { text: 'ドット', value: 'dotted' }
      ],
      currentTarget: null,
      border: {
        style: null,
        width: null,
        color: null,
      },
      labelText: null,
      isShowExtraOption: false,
      interval: null,
    }
  },
  computed: {
    // 表示しているカラーピッカー
    currentColorPicker () {
      return this.$store.getters.getStatusColorPicker
    },
    showColorPicker: function () {
      return function (target) {
        return this.currentColorPicker.pane === 'palette' && this.currentColorPicker.prop === target
      }
    },
    // 画面に表示する色名
    displayColorText () {
      return this.border.color || '未設定'
    },
    // カラーチップ
    activeColorStyle () {
      const activeColorStyle = {
        'background': this.border.color || '#FFFFFF'
      }
      // 白背景の場合、見えなくなってしまうので枠線を付ける
      activeColorStyle['border'] = activeColorStyle.background === '#FFFFFF' ? '1px solid #c6c6c6' : `1px solid ${this.border.color}`
      return activeColorStyle
    }
  },
  methods: {
    initBorder () {
      const border = this.value
      if (border) {
        // スタイルが半角スペース区切りで取得できるので、それぞれの項目に分ける
        const borderStyles = border.split(' ')
        this.border.style = borderStyles[0]
        if (borderStyles[1]) this.border.width = borderStyles[1].replace(/px/g, '')
        if (borderStyles[2]) this.border.color = borderStyles[2]
      } else {
        this.border.style = 'none'
      }
    },
    clickColorForm (target) {
      this.currentTarget = target
      this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: 'palette' })
      this.$store.commit('updateStatusColorPicker', { prop: 'prop', value: target })

      // カラーピッカーの初期値をセット
      this.border.color = this.border.color ? this.border.color : '#000000'
    },
    colorPickerAway () {
      if (this.currentColorPicker.pane === 'palette' && this.currentColorPicker.prop === this.currentTarget) {
        this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: null })
        this.$store.commit('updateStatusColorPicker', { prop: 'prop', value: null })
      }
    },
    changeBorderColor (value) {
      this.border.color = value
    },
    updateBorder (borderStyle) {
      if (!this.target) return null
      const updateValue = borderStyle !== 'none' ? borderStyle : null
      let styles
      // テキストボックス、画像カードはtarget名の前にパーツ名 + アンダーバーが付与されている：replaceで除去した状態で判定
      if (this.target.replace(/boxedtext_/, '').replace(/imagecard_/, '') === 'border' && this.type !== 'partsContainer') {
        // 更新対象が border かつ タイプがパーツコンテナ以外の場合、四方向に同じ値を設定
        styles = [
          { prop: 'border-top', value: updateValue },
          { prop: 'border-bottom', value: updateValue },
          { prop: 'border-left', value: updateValue },
          { prop: 'border-right', value: updateValue }
        ]
      } else {
        styles = [
          { prop: this.target, value: updateValue }
        ]
      }
      this.$emit('updateStyles', styles)
    },
    // 太さ変更ボタンを押す
    countWeight (target) {
      const checkValue = Number(this.border.width)
      // 数値の場合のみ更新する
      if (Number.isInteger(checkValue)) {
        // 必ず1は増減させる
        if (target === 'plus' && this.border.width < MAX_BORDER_WIDTH) this.border.width++
        if (target === 'minus' && this.border.width > MIN_BORDER_WIDTH) this.border.width--

        // 長押しで入力値を増減させる
        if (!this.interval) {
          this.interval = setInterval(() => {
            if (target === 'plus' && this.border.width < MAX_BORDER_WIDTH) this.border.width++
            if (target === 'minus' && this.border.width > MIN_BORDER_WIDTH) this.border.width--
          }, 100)
        }
      }
    },
    // 太さ変更ボタンを離す
    changeWeight (target) {
      // 増減を解除
      clearInterval(this.interval)
      this.interval = null
    }
  },
  watch: {
    'border.style' (value) {
      this.isShowExtraOption = (value !== 'none')

      // none選択時
      if (value === 'none') {
        // 色と太さを空にしておく
        this.border.color = null
        this.border.width = null

        // カラーピッカーが表示されていたら、非表示にする
        if (this.showColorPicker) {
          this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: null })
          this.$store.commit('updateStatusColorPicker', { prop: 'prop', value: null })
        }
      }
    },
    border: {
      deep: true,
      handler: function (value) {
        if (!this.border) return null
        let borderStyle = null
        if (this.border.style === 'none' || this.border.width === 0 || this.border.width === '0') {
          // 枠線未設定、太さ0px(選択および直接入力対応)
          borderStyle = 'none'
        } else if (this.border.style && this.border.width && this.border.color) {
          // 太さ：整数が入力されていた場合のみ更新
          const checkValue = Number(this.border.width)
          // 最大入力値より大きい値は最大入力値に変換
          if (checkValue > MAX_BORDER_WIDTH) this.border.width = MAX_BORDER_WIDTH
          if (Number.isInteger(checkValue) && checkValue > MIN_BORDER_WIDTH) {
            borderStyle = this.border.style + ' ' + this.border.width + 'px ' + this.border.color
          }
        }
        if (borderStyle) this.updateBorder(borderStyle)
      }
    }
  },
  beforeMount () {
    this.options = this.initOptions(this.target)
  },
  mounted () {
    this.initBorder()
    this.labelText = this.initLabelText(this.target)
  }
}
</script>

<style lang="scss" scoped>
.edit-style-border {
  position: relative;
  .text, .color {
    width: 250px;
    margin: 10px;
    overflow: hidden;
    position: relative;
    border: 0.5px solid #c6c6c6;
    border-radius: 4px;
    background: #ffffff;
    display: inline-block;
    &>div {
      width: 100%;
      cursor: pointer;
      text-indent: 0.01px;
      text-overflow: ellipsis;
      border: none;
      outline: none;
      background: transparent;
      background-image: none;
      box-shadow: none;
      appearance: none;
      color: #666666;
    }
  }
  .text-color-box {
    display: inline-block;
    vertical-align: top;
  }
  .weight {
    position: relative;
    .common-input {
      width: 80px;
      &::after {
        content: 'px';
        color: $commonFontColor;
        position: absolute;
        bottom: 6px;
        right: 24px;
      }
      // 罫線太さのボタン
      .weight-button {
        width: 15px;
        height: 15px;
        position: absolute;
        // ボタン本体 共通スタイル
        button {
          cursor: pointer;
          width: 0;
          height: 0;
          position: absolute;
        }
      }
      // 罫線太さのボタン：プラス
      .plus-button-wrapper {
        top: 4px;
        right: 4px;
        .plus-button {
          position: absolute;
          top: 8px;
          right: 2px;
          border-style: solid;
          border-width: 0 4.5px 6px 4.5px;
          border-color: transparent transparent #666666 transparent;
          &:hover {
            border-color: transparent transparent #aaaaaa transparent;
          }
        }
      }
      // 罫線太さのボタン：マイナス
      .minus-button-wrapper {
        bottom: 2px;
        right: 4px;
        .minus-button {
          position: absolute;
          bottom: 8px;
          right: 2px;
          border-style: solid;
          border-width: 6px 4.5px 0 4.5px;
          border-color: #666666 transparent transparent transparent;
          &:hover {
            border-color: #aaaaaa transparent transparent transparent;
          }
        }
      }
    }
  }
  .common-input {
    line-height: 1.3;
    &.color-custom {
      width: 105px;
      margin: 0;
      color: $commonFontColor;
      font-family: $defaultFontFamily;
      font-size: 14px;
      .color-picker-label {
        line-height: 1.5;
        display: flex;
        align-items: center;
        .active-color {
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 4px;
          border-radius: 2px;
        }
      }
    }
  }
  .flex-box {
    display: flex;
    align-items: flex-end;
    .margin-none {
      > div {
        margin: 0;
      }
    }
    &:last-of-type {
      padding: 0;
    }
  }
}
</style>

<style lang="scss">
.edit-style-border {
  .editor-design {
    .common-select {
      margin: 0;
    }
  }
  .window {
    top: 58px;
    right: 0;
  }
}
</style>
